import vehiclePlate from './vehiclePlate'
import people from './people'
import odor from './odor'
import nilometer from './nilometer'

export default {
	state: {
	},
	modules: {
		vehiclePlate,
		people,
		odor,
		nilometer,
	},
}